import "./App.css";
import React, { useState, useEffect } from "react";
import { AppNavbar } from "./components/AppNavbar";
import { PriceTrend } from "./components/PriceTrend";
// import Select from "react-select";
// import data from "../data/data.json";
import { YearlyGraph } from "./components/YearlyGraph";
const App = () => {
  const [crop, setCrop] = useState(null);
  const [market, setMarket] = useState(null);
  const [creationDate, setCreationDate] = useState(null);
  const [priceTrend, setPriceTrend] = useState([]);
  const [yearlyGraph, setYearlyGraph] = useState([]);
  let base64 = require("base-64");

  let today =
    new Date().getFullYear() +
    "-" +
    String(new Date().getMonth() + 1).padStart(2, "0") +
    "-" +
    String(new Date().getDate()).padStart(2, "0");

  useEffect(() => {
    let payload = new URLSearchParams(window.location.search).get("payload");
    payload = payload.replaceAll(" ", "+");
    fetch("https://aryaag.agtuall.com:8443/key_decrypt", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " + base64.encode("arya_priceuser:gHAYbqhq5Bd7DQKw"),
      },
      body: JSON.stringify({
        encrypt_key: payload,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // setDecryptedData(data);
        setCrop(data["crop"]);
        setMarket(data["market"]);
        setCreationDate(data["created_at"]);
      });
  }, [base64]);

  useEffect(() => {
    if (crop !== null && market !== null) {
      fetch("https://aryaag.agtuall.com:8443/chart1_data", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Basic " + base64.encode("arya_priceuser:gHAYbqhq5Bd7DQKw"),
        },
        body: JSON.stringify({
          crop: crop,
          market: market,
          start_date:
            new Date().getFullYear() -
            3 +
            "-" +
            String(new Date().getMonth() + 1).padStart(2, "0") +
            "-" +
            String(new Date().getDate()).padStart(2, "0"),
          end_date:
            new Date().getFullYear() +
            "-" +
            String(new Date().getMonth() + 1).padStart(2, "0") +
            "-" +
            String(new Date().getDate()).padStart(2, "0"),
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          setPriceTrend(data);
        });

      fetch("https://aryaag.agtuall.com:8443/getPrices", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Basic " + base64.encode("arya_priceuser:gHAYbqhq5Bd7DQKw"),
        },
        body: JSON.stringify({
          crop: crop,
          market: market,
          start_date: new Date().getFullYear() - 3 + "-01-01",
          end_date:
            new Date().getFullYear() +
            "-" +
            String(new Date().getMonth() + 1).padStart(2, "0") +
            "-" +
            String(new Date().getDate()).padStart(2, "0"),
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data !== "No records found") {
            setYearlyGraph(data);
          }
        });
    }
  }, [crop, market, base64]);
  return (
    <>
      {crop !== null && market !== null && creationDate === today ? (
        <>
          <AppNavbar />

          <div className="row justify-content-center">
            <div className="col-md-11">
              <PriceTrend data={priceTrend} crop={crop} market={market} />
            </div>
          </div>
          <div className="row justify-content-center mt-4">
            <div className="col-md-10">
              <YearlyGraph data={yearlyGraph} crop={crop} market={market} />
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default App;
